import React, { useContext, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { CanvasContext } from "./CanvasContext";
import FabricCanvas from "./FabriCanvas";
import { GridCanvas } from "./GridCanvas";

function Canvas({ previewMode, slideTransition, initialColor }) {
  const editorRef = useRef(null);
  const { canvas } = useContext(CanvasContext);
  const { bottomBarExpanded } = useSelector((state) => state.ui);
  const { showGrid } = useSelector((state) => state.grid);
  const { isOnlyAvatar } = useSelector((state) => state.project);
  console.log("showGrid", showGrid);

  const deActivateObject = (e) => {
    if (!previewMode && canvas) {
      const activeObject = canvas.getActiveObject();

      if (activeObject && !editorRef.current?.contains(e.target)) {
        canvas.discardActiveObject().renderAll();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("click", deActivateObject);
    return () => {
      document.removeEventListener("click", deActivateObject);
    };
  }, [canvas]);
  return (
    <div
      ref={editorRef}
      className={`flex-grow flex justify-center items-center p-4 border-b border-gray-300 bg-black-200 h-full pb-16`}
    >
      <FabricCanvas
        id="canvas"
        previewMode={previewMode}
        slideTransition={slideTransition}
        initialColor={initialColor}
      />

      {showGrid && !previewMode && <GridCanvas />}
    </div>
  );
}

export default Canvas;
